import React, { useState } from "react";
import { Row, Col, ProgressBar, Image } from "react-bootstrap";
import { useInView } from "react-intersection-observer";

// FrontEnd Icons
import htmlLogo from "../../Assets/Icons/html.png";
import cssLogo from "../../Assets/Icons/css.png";
import jsLogo from "../../Assets/Icons/js.png";
import reactLogo from "../../Assets/Icons/react.png";
import typescriptLogo from "../../Assets/Icons/typerscript.png";

// BackEnd Icons
import phpLogo from "../../Assets/Icons/php.png";
import sqlLogo from "../../Assets/Icons/sql.png";
import nodeLogo from "../../Assets/Icons/node.png";
import symfonyLogo from "../../Assets/Icons/symfony.png";
import laravelLogo from "../../Assets/Icons/laravel.png";

// Other Icons
import gitLogo from "../../Assets/Icons/git.svg";
import githubLogo from "../../Assets/Icons/github.png";
import gitlabLogo from "../../Assets/Icons/gitlab.png";
import bashLogo from "../../Assets/Icons/bash.png";
import windowsLogo from "../../Assets/Icons/windows.png";
import ubuntuLogo from "../../Assets/Icons/ubuntu.svg";
import glpiLogo from "../../Assets/Icons/GLPI.png";
import vscodeLogo from "../../Assets/Icons/vscode.svg";
import claudeLogo from "../../Assets/Icons/claude.webp";
import notionLogo from "../../Assets/Icons/notion.png";
import kritaLogo from "../../Assets/Icons/krita.svg";
import dbgateLogo from "../../Assets/Icons/dbgate.png";
import Tilt from "react-parallax-tilt";

const frontEndSkills = [
    { name: "HTML", value: 90, icon: htmlLogo, color: "HTML_COLOR" },
    { name: "CSS", value: 80, icon: cssLogo, color: "CSS_COLOR" },
    { name: "JavaScript", value: 75, icon: jsLogo, color: "JS_COLOR" },
    { name: "React", value: 70, icon: reactLogo, color: "REACT_COLOR" },
    { name: "TypeScript", value: 45, icon: typescriptLogo, color: "TS_COLOR" },
];

const backEndSkills = [
    { name: "PHP", value: 90, icon: phpLogo, color: "PHP_COLOR" },
    { name: "SQL", value: 80, icon: sqlLogo, color: "SQL_COLOR" },
    { name: "NodeJs", value: 40, icon: nodeLogo, color: "NODE_COLOR" },
    { name: "Symfony", value: 75, icon: symfonyLogo, color: "SYMFONY_COLOR" },
    { name: "Laravel", value: 70, icon: laravelLogo, color: "LARAVEL_COLOR" },
];

const tools = [
    { icon: gitLogo, alt: "Git" },
    { icon: githubLogo, alt: "GitHub" },
    { icon: gitlabLogo, alt: "GitLab" },

    { icon: bashLogo, alt: "Bash" },
    { icon: windowsLogo, alt: "Windows" },
    { icon: ubuntuLogo, alt: "Ubuntu" },

    { icon: glpiLogo, alt: "GLPI" },
    { icon: vscodeLogo, alt: "VSCode" },
    { icon: claudeLogo, alt: "Claude" },

    { icon: notionLogo, alt: "Notion" },
    { icon: kritaLogo, alt: "Krita" },
    { icon: dbgateLogo, alt: "DBgate" },
];

const skillIconStyle = { width: "50px", height: "40px", objectFit: "contain", flexShrink: 0 };
const toolIconStyle = { width: "50px", height: "50px", objectFit: "contain" };

const SkillBars = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
    <>
        <div ref={ref}>
        <Row>
            <Col md={4} style={{ paddingRight: "30px", paddingLeft: "30px" }}>
            <h3 className={`sub-heading ${inView ? "is-visible" : ""}`}>Front-End</h3>
            {frontEndSkills.map((skill, idx) => (
                <div
                    key={idx}
                    className="mb-4 d-flex align-items-center skill-row"
                    onMouseEnter={() => setHoveredIndex("ft" + idx)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <span className="me-3 has-tooltip" data-tooltip={skill.name}>
                        <Image
                            src={skill.icon}
                            alt={skill.name}
                            style={skillIconStyle}
                        />
                    </span>
                    <div style={{ width: "100%" }}>
                        <ProgressBar
                            animated={hoveredIndex === "ft" + idx}
                            now={inView ? skill.value : 0}
                            variant={skill.color}
                            className="progress-bar-hover"
                        />
                    </div>
                </div>
            ))}
            </Col>

            <Col md={4} style={{ paddingRight: "30px", paddingLeft: "30px" }}>
            <h3 className={`sub-heading ${inView ? "is-visible" : ""}`}>Back-End</h3>
            {backEndSkills.map((skill, idx) => (
                <div
                    key={idx}
                    className="mb-4 d-flex align-items-center skill-row"
                    onMouseEnter={() => setHoveredIndex("bc" + idx)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <span className="me-3 has-tooltip" data-tooltip={skill.name}>
                        <Image
                            src={skill.icon}
                            alt={skill.name}
                            style={skillIconStyle}
                        />
                    </span>
                    <div style={{ width: "100%" }}>
                        <ProgressBar
                            animated={hoveredIndex === "bc" + idx}
                            now={inView ? skill.value : 0}
                            variant={skill.color}
                            className="progress-bar-hover"
                        />
                    </div>
                </div>
            ))}
            </Col>

            <Col md={4} style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                <h3 className={`sub-heading ${inView ? "is-visible" : ""}`}>Outils / Autres</h3>
                <Row>
                    {tools.map((tool, idx) => (
                        <Col xs={4} key={idx} className="mb-3 d-flex justify-content-center align-items-center">
                            <div className="has-tooltip" data-tooltip={tool.alt}>
                                <Tilt className="tool-tile" scale={1.08}>
                                    <Image
                                        src={tool.icon}
                                        alt={tool.alt}
                                        style={toolIconStyle}
                                    />
                                </Tilt>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
        </div>
    </>
    );
};

export default SkillBars;